module.exports = __webpack_public_path__ + "static/module-patreon-7ef3e18d201884020d6cd5fe2e62cebf.jpg";